import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import './index.css';
import 'config/setVariables';
import { configureCognito } from 'config/Cognito/cognitoConfig';
import { startMockWorker } from 'config/mocks/browser';
import { getEnvironments } from 'store/useAtomOutsideComponent';
import {
  ensureSecureConfigLoaded,
  startSecureConfigWatcher,
} from 'utils/secureConfigBootstrap';
import { getStringFromLocalStorage } from 'utils/localStorage';
import { refreshEnvVars } from 'config/variables';
import { isPostHogEnabled } from 'config/analytics/posthog';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

// Initialize Cognito
configureCognito();

(async () => {
  try {
    const hasSession = !!getStringFromLocalStorage('token');
    // Espera los secrets antes de importar la app. Con sesión activa, espera
    // el token de Firebase/Cognito. Sin sesión, intenta con lo que haya
    // y sigue si no hay nada (ruta pública).
    await ensureSecureConfigLoaded({ waitForToken: hasSession });

    // Propaga lo que llegó al store hacia las constantes de config/variables.
    // Los módulos que se carguen después (incluidos los lazy chunks) ya leerán
    // los valores correctos a través de las live bindings.
    refreshEnvVars();

    startSecureConfigWatcher();

    const { REACT_APP_ENABLE_MOCKS } = getEnvironments({
      keys: ['REACT_APP_ENABLE_MOCKS'],
    });

    if (
      process.env.REACT_APP_ENABLE_MOCKS === 'true' ||
      REACT_APP_ENABLE_MOCKS === 'true'
    ) {
      startMockWorker();
    }

    const App = (await import('./App/App')).default;

    ReactDOM.render(
      <React.StrictMode>
        {isPostHogEnabled() ? (
          <PostHogProvider client={posthog}>
            <App />
          </PostHogProvider>
        ) : (
          <App />
        )}
      </React.StrictMode>,
      document.getElementById('root'),
    );
  } catch (e) {
    console.error('Error loading app', e);
  }
})();
